<div
  [ngClass]="title ? 'tw-items-start' : 'tw-items-center'"
  class="tw-flex tw-w-full tw-min-w-[350px] tw-gap-2.5 tw-rounded-xl tw-border tw-border-color-status-error-border tw-bg-color-status-error-bg tw-px-3.5 tw-py-3 tw-text-color-status-error-text md:tw-min-w-[300px]"
>
  <icon
    [name]="'info-danger'"
    [size]="4"
    class="tw-shrink-0"
    [ngClass]="{ 'tw-mt-0.5': title }"
  ></icon>
  <div class="tw-flex tw-flex-col tw-gap-0.5">
    @if (title) {
      <span class="tw-whitespace-nowrap tw-text-[13px] tw-font-semibold">{{ title | i18n }}</span>
    }
    <p class="tw-m-0 tw-text-[12px]">{{ body | i18n }}</p>
  </div>
</div>
